export const LOCALES = {
  FRENCH: 'fr',
  SPANISH: 'es',
  ENGLISH: 'en',
  GERMAN: 'de',
  ITALIAN: 'it',
};

export const PLATFORMS = {
  FRANCE: 'fr',
  SPAIN: 'es',
  GREAT_BRITAIN: 'gb',
  GERMANY: 'de',
  ITALY: 'it',
};

// TODO: REACT-346 (How to handle static images CDN_URL)
export const IMG_CDN_URL =
  'https://cdn.manomano.com/files/dist/img/themes/default';

export const isB2BVisible = (platform, isAuthenticated, isB2B) =>
  (platform === PLATFORMS.FRANCE ||
    platform === PLATFORMS.SPAIN ||
    platform === PLATFORMS.ITALY) &&
  !(isAuthenticated && isB2B);
